import { Modal } from 'antd';
import styled from 'styled-components';
import {
  englishFlagImage, koreanFlagImage, primaryHeadingColor, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import { IsMobileSm } from 'Utils/UtilityFunctions';
import { LanguageEnum } from 'Utils/Constants';
import CrossCircle from '../assets/svgIcons/CrossCircle';
import GilroyNewSvg from '../assets/svgIcons/GilroyNewSvg';

type Props = {
  showPopup: boolean
  onClickCancel: () => void
  downloadPersonProfile: (language: string) => void
};

const MarketingModal = styled(Modal)`
 .ant-modal-content {
  .ant-modal-close {
    .ant-modal-close-x {
      width: 44px;
      .cross-icon-x {
        .cross-circle-svg {
          width: 24px;
          height: 24px;
          margin: 16px 16px 0px 0px;
        }
      }
    }
  }
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 22px;
    padding-top: 33px;
    padding-bottom: 33px;
    .gilroy-new-svg {
      width: 63.929px;
      height: 51.515px;
      margin-bottom: 17px;
    }
    .download-popup-title {
      color: ${primaryHeadingColor};
      text-align: center;
      font-family: ${secondaryFont};
      font-size: 22px;
      font-weight: ${wMBold};
      line-height: 28.491px;
      letter-spacing: -0.95px;
      margin-bottom: 16px;
      &.button-text {
        font-size: 14px;
        line-height: normal;
        margin-bottom: 0px;
      }
    }
    .buttons-div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .button-style {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 168px;
        height: 34px;
        border-radius: 16px;
        border: 1px solid #C3C3C3;
        padding: 5px 7px;
        cursor: pointer;
        &:first-child {
          margin-bottom: 12px;
        }
        .flag-circle {
          width: 22px;
          height: 22px;
          flex-shrink: 0;
        }
        .empty-div {
          width: 22px;
        }
      }
    }
  }
  .ant-modal-footer {
    display: none;
  }
 }
`;

const DownloadProfileLanguagePopup = function DownloadProfileLanguagePopup(
  {
    showPopup, onClickCancel, downloadPersonProfile,
  }: Props,
) {
  const isSm = IsMobileSm();
  return (
    <MarketingModal
      centered
      width={isSm ? 350 : 406}
      closeIcon={<div className="cross-icon-x"><CrossCircle /></div>}
      getContainer=""
      wrapClassName="marketing-popups"
      visible={showPopup}
      onCancel={onClickCancel}
      closable
    >
      <GilroyNewSvg />
      <h5 className="download-popup-title">Which language do you want to download the PDF in?</h5>
      <div className="buttons-div">
        <span
          role="button"
          tabIndex={0}
          className="button-style"
          onKeyPress={() => {
            downloadPersonProfile(LanguageEnum.KOREAN);
          }}
          onClick={() => {
            downloadPersonProfile(LanguageEnum.KOREAN);
          }}
        >
          <img src={koreanFlagImage} alt="flag" className="flag-circle" />
          <span className="download-popup-title button-text">{LanguageEnum.KOREAN}</span>
          <div className="empty-div" />
        </span>
        <span
          role="button"
          tabIndex={0}
          className="button-style"
          onKeyPress={() => {
            downloadPersonProfile(LanguageEnum.ENGLISH);
          }}
          onClick={() => {
            downloadPersonProfile(LanguageEnum.ENGLISH);
          }}
        >
          <img src={englishFlagImage} alt="flag" className="flag-circle" />
          <span className="download-popup-title button-text">{LanguageEnum.ENGLISH}</span>
          <div className="empty-div" />
        </span>
      </div>
    </MarketingModal>
  );
};
export default DownloadProfileLanguagePopup;
